<script lang="ts">
  import Icon from '../Icon.svelte';

  export let icon: string;

  export let additionalClasses: string = '';
</script>

<div class="card-text {additionalClasses}">
  <div class="row">
    <div class="col-auto align-self-center pe-1">
      <Icon {icon}></Icon>
    </div>

    <div class="col align-self-center">
      <slot></slot>
    </div>
  </div>
</div>
